import { render, staticRenderFns } from "./su2Details.vue?vue&type=template&id=c7aabaae&scoped=true"
import script from "./su2Details.vue?vue&type=script&lang=js"
export * from "./su2Details.vue?vue&type=script&lang=js"
import style0 from "./su2Details.vue?vue&type=style&index=0&id=c7aabaae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7aabaae",
  null
  
)

export default component.exports